// extracted by mini-css-extract-plugin
export default {"menuItemDropdown":"scheduler_menuItemDropdown__zy6RR","popover":"scheduler_popover__gP9WN"};